import * as React from "react";
import TablePagination from '@mui/material/TablePagination';
import { PAGE_SIZES } from "../../utils/constants";
export const Pagination = ({currentPage,pageSize,totalRecords,onPaginationChange}) => {
  const handleChangePage = (_, newPage) => {
    onPaginationChange({
        page:newPage+1,
        pageSize:pageSize
    })
  };
  const handleChangeRowsPerPage = (event) => {
    const pageSizeVal = parseInt(event.target.value, 10);
    if(totalRecords<=PAGE_SIZES[0]){
        return;
    }
    onPaginationChange({
        page:1,
        pageSize:pageSizeVal
    })
  };

  return (
    <TablePagination
      component="div"
      count={totalRecords}
      page={Math.max(currentPage-1,0)}
      onPageChange={handleChangePage}
      rowsPerPage={pageSize}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={PAGE_SIZES}
    />
  );
};
